import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSubscription } from '../contexts/SubscriptionContext';

/**
 * Navigation Bar Component
 * Displays main navigation links and user menu
 */
const Navbar = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const { isSubscribed } = useSubscription();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav>
      <div className="nav-container">
        <Link to="/" style={{ fontSize: '24px', fontWeight: 'bold', textDecoration: 'none', color: 'var(--highlight-color)' }}>
          🚀 RocketVerse
        </Link>
        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/agencies">Agencies</Link></li>
          <li><Link to="/rockets">Rockets</Link></li>
          <li><Link to="/launches">Launches</Link></li>
          <li><Link to="/scientists">Scientists</Link></li>
          <li><Link to="/satellites">Satellites</Link></li>
          <li><Link to="/articles">Articles</Link></li>
          <li><Link to="/news">News</Link></li>
          <li><Link to="/marketplace">Marketplace</Link></li>
          <li><Link to="/physics-lab">Physics Lab</Link></li>
          {isAuthenticated() && isSubscribed() && (
            <li><Link to="/chat">Chat</Link></li>
          )}
          {!isAuthenticated() ? (
            <>
              <li><Link to="/login">Login</Link></li>
              <li><Link to="/register">Register</Link></li>
            </>
          ) : (
            <>
              <li><Link to="/profile">Profile</Link></li>
              {!isSubscribed() && <li><Link to="/subscription">Subscribe</Link></li>}
              <li><button onClick={handleLogout} className="btn btn-secondary" style={{ marginLeft: '10px' }}>Logout</button></li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
